import { useMemo } from 'react'

import { useLocation } from 'react-router-dom'

export const usePrevPath = () => {
  const { pathname } = useLocation()
  const prevPath = useMemo(() => {
    const seg = pathname.split('/')
    seg.pop()
    return seg.join('/')
  }, [pathname])

  return prevPath
}
